import { useState, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';

/**
 * Hook que encapsula estado, flags y handlers de EPP para ItemsSection.
 * Se llama incondicionalmente (reglas de hooks) pero la lógica solo aplica cuando guide_category === 'epp'.
 */
export function useEPPItems(validation) {
	const [isRetiroModalOpen, setIsRetiroModalOpen] = useState(false);

	const isRetiroEPP = useMemo(() => {
		return (
			validation.values.guide_category === 'epp' &&
			validation.values.epp_operation_type === 'retiro'
		);
	}, [validation.values.guide_category, validation.values.epp_operation_type]);

	const handleRetiroConfirm = useCallback(
		(transformedItems, selectedEPPs, observations) => {
			validation.setFieldValue('items', transformedItems, false);

			if (observations) {
				validation.setFieldValue('observaciones_guia', observations, false);
			}

			toast.success(
				`${selectedEPPs.length} EPP(s) seleccionados → ${transformedItems.length} item(s) agregados`,
			);
		},
		[validation],
	);

	return {
		isRetiroModalOpen,
		setIsRetiroModalOpen,
		isRetiroEPP,
		handleRetiroConfirm,
	};
}
